import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index(vuexContext, { perPage, page, selectedSocialTypes, selectedSentiments }) {
        const params = {
            page,
            perPage,
            user_id: 1, // @TMP hardcoded user_id to try to fetch fake data in e.g. demo
            selected_sentiments: selectedSentiments,
            selected_social_types: selectedSocialTypes
        };

        return axios.getMethodOverridePost('/v1/dashboard/most-impactful-posts', {
            params
        });
    }
};
